<template>
    <div class="news-feed">
        <div v-if="newsFeed.length == 0" class="no-articles">
            No articles found.
        </div>
        <router-link v-else v-for="item in newsFeed" :key="item.Id" :to="`/news/${item.UrlStub}`" class="news-item">
            <img v-if="thumb && item.Media && !extractYoutubeVideoId(item.Media)" :src="item.Media" alt="News Media" class="news-thumbnail">
            <img v-else-if="thumb && item.Media && extractYoutubeVideoId(item.Media)" :src="`https://img.youtube.com/vi/${extractYoutubeVideoId(item.Media)}/maxresdefault.jpg`" alt="News Media" class="news-thumbnail">
            <img v-else-if="thumb" src="/img/news_article_cover.jpg" alt="News Media" class="news-thumbnail">
            <div class="news-content">
                <h4 class="title is-5" style="margin-bottom: 0;">{{ item.Title }}</h4>
                <p class="news-summary">{{ item.Summary ? item.Summary : "No summary available." }}</p>
                <p class="news-author">By <router-link :to="`/profiles/${item.Author}`">{{ item.Author }}</router-link> on {{ formatDate(item.CreatedAt) }}</p>
                <div class="news-tags" v-if="item.Games && item.Games.length > 0">
                    <span v-for="game in item.Games" :key="game" class="news-tag">
                        {{ gameNames.get(game) }}
                    </span>
                </div>
            </div>
        </router-link>
    </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { NewsArticle } from "@/api";
import TimeService from "@/services/TimeService";

@Component({
    components: {}
})
export default class NewsFeed extends Vue {

    @Prop()
    newsFeed: NewsArticle[] = new Array();

    @Prop()
    gameNames: Map<string, string> = new Map<string,string>();

    @Prop()
    thumb: boolean = true;

    formatDate(date: string): string {
        return TimeService.iso8601ToShortFormat(date);
    }

    extractYoutubeVideoId(url: string): string | null {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        return match ? match[1] : null;
    }
}

</script>
<style lang="scss" scoped>
@use "@/assets/haloruns_vars.scss" as *;

.no-articles {
    color: gray;
    text-align: center;
    padding: 2rem;
    border-bottom: 1px solid #374d7f;;
}

.news-feed {
    display: flex;
    flex-direction: column;
    width: calc(100% + 30px);
    margin-left: -15px;
    border-top: 2px solid #374d7f;
    border-bottom: 1px solid #374d7f;
    border-collapse: collapse;
    margin-bottom: 1.5rem;
}

.news-item {
    color: white;
    display: flex;
    gap: 1rem;
    padding: 1rem;
    border-bottom: 1px solid #374d7f;
    height: 12rem;
    overflow: hidden;
}

.title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
}

.news-item:nth-child(even) {
    background-color: rgba(128, 230, 255, 0.05);
}

.news-item:hover {
    background-color: rgba(128, 230, 255, 0.1);
    cursor: pointer;
}

.news-thumbnail {
    max-width: 25%;
    aspect-ratio: 16/9;
    object-fit: cover;
    border-radius: 8px;
}

.news-content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 0;
}

.news-summary {
    color: gray;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    height: 3rem;
}

.news-author {
    margin-top: auto;
}

.news-tags {
    display: flex;
    gap: 0.5rem;
    margin-top: auto;
    overflow-x: auto;
    scrollbar-width: none;
}

.news-tags::-webkit-scrollbar{
    display: none;
}

.news-tag {
    background-color: gray;
    color: white;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    white-space: nowrap;
}

@media only screen and (max-width: 768px) {
    .news-thumbnail {
        height: 5rem;
    }
}


</style>
